import type { SVGProps } from 'react';
const SvgIconCompany = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}>
    <path
      fill="currentColor"
      d="M5 4a.25.25 0 0 0-.25.25v2c0 .138.112.25.25.25h2a.25.25 0 0 0 .25-.25v-2A.25.25 0 0 0 7 4zm-.25 4A.25.25 0 0 1 5 7.75h2a.25.25 0 0 1 .25.25v2a.25.25 0 0 1-.25.25H5a.25.25 0 0 1-.25-.25zM9 4a.25.25 0 0 0-.25.25v2c0 .138.112.25.25.25h2a.25.25 0 0 0 .25-.25v-2A.25.25 0 0 0 11 4zm-.25 4A.25.25 0 0 1 9 7.75h2a.25.25 0 0 1 .25.25v2a.25.25 0 0 1-.25.25H9a.25.25 0 0 1-.25-.25z"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M11.5 1h-7A2.5 2.5 0 0 0 2 3.5v9A2.5 2.5 0 0 0 4.5 15h7a2.5 2.5 0 0 0 2.5-2.5v-9A2.5 2.5 0 0 0 11.5 1m-8 2.5a1 1 0 0 1 1-1h7a1 1 0 0 1 1 1v9a1 1 0 0 1-1 1H9.75v-1.75a.25.25 0 0 0-.25-.25h-3a.25.25 0 0 0-.25.25v1.75H4.5a1 1 0 0 1-1-1z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgIconCompany;
